import { useEffect, useState } from 'react';

import { TobaccoOfferType } from '@occc/graphql';

import { RetailerNetworkTobaccoOffersSection } from './retailer-network-tobacco-offers-section.component';

import { useRetailerNetworkTobaccoManufacturerOfferPerformance } from '../../hooks/use-retailer-network-tobacco-manufacturer-offer-performance.hook';

type RetailerNetworkTobaccoOffersSectionControllerProps = {
  title: string;
  retailerNetworkUuid: string;
  manufacturerProgramId: string;
  startDate: Date;
  endDate: Date;
  isExpanded: boolean;
};

export const RetailerNetworkTobaccoOffersSectionController = ({
  title,
  manufacturerProgramId,
  retailerNetworkUuid,
  startDate,
  endDate,
  isExpanded,
}: RetailerNetworkTobaccoOffersSectionControllerProps) => {
  const [expanded, setExpanded] = useState(isExpanded);
  const [hasEverExpanded, setHasEverExpanded] = useState(isExpanded);

  useEffect(() => {
    if (expanded && !hasEverExpanded) {
      setHasEverExpanded(true);
    }
  }, [expanded, hasEverExpanded]);

  // Track if we've ever expanded to avoid re-fetching
  const shouldFetch = expanded || hasEverExpanded;

  const { data: loyaltyData = [], loading: loyaltyLoading } =
    useRetailerNetworkTobaccoManufacturerOfferPerformance({
      filter: {
        manufacturerIdEquals: manufacturerProgramId,
        retailerNetworkUuidEquals: retailerNetworkUuid,
        offerTypeEquals: TobaccoOfferType.Loyalty,
        dateFromEquals: startDate.toISOString(),
        dateToEquals: endDate.toISOString(),
      },
      baseOptions: {
        skip: !shouldFetch,
      },
    });

  const { data: multiUnitData = [], loading: multiUnitLoading } =
    useRetailerNetworkTobaccoManufacturerOfferPerformance({
      filter: {
        manufacturerIdEquals: manufacturerProgramId,
        retailerNetworkUuidEquals: retailerNetworkUuid,
        offerTypeEquals: TobaccoOfferType.MultiUnit,
        dateFromEquals: startDate.toISOString(),
        dateToEquals: endDate.toISOString(),
      },
      baseOptions: {
        skip: !shouldFetch,
      },
    });

  return (
    <RetailerNetworkTobaccoOffersSection
      title={title}
      multiUnitOffers={multiUnitData}
      loyaltyOffers={loyaltyData}
      loading={loyaltyLoading || multiUnitLoading}
      defaultExpanded={isExpanded}
      setExpanded={setExpanded}
    />
  );
};
